import { makeStyles } from '@forgeglobal/design-framework';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.MuiDrawer-root .MuiListItem-button h6': {
      marginTop: 4, // mimic proposed leading-trim CSS rule to align baseline and in center
    },
  },
  navCard: {
    width: '90%',
    borderRadius: '8px',
    transition: 'opacity 0.5s',
    transitionDelay: '0.3s',
  },
  navCardInvisible: {
    marginRight: theme.spacing(3.5),
    paddingRight: theme.spacing(3.5),
  },
  isInvisible: {
    opacity: 0,
    maxHeight: '0px',
    visibility: 'hidden',
    display: 'none',
  },
  isMobile: {
    opacity: 1,
    maxHeight: 'revert',
    visibility: 'visible',
  },
  footerContent: {
    padding: theme.spacing(2, 1.5),
  },
  footerTitle: {
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  headerText: {
    lineHeight: '24px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  logo: {
    paddingLeft: theme.spacing(1),
  },
  logoLink: {
    cursor: 'pointer',
    height: theme.spacing(4),
    marginRight: 100,
    [theme.breakpoints.down('md')]: {
      marginRight: theme.spacing(4),
    },
  },
  desktopSearch: {
    width: 480,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  searchButton: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  mobileSearch: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'none',
    zIndex: 100,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      marginLeft: 'auto',
    },
  },
  mobileSearchInput: {
    height: `${theme.spacing(8)} !important`,
  },
  notDisplayed: { display: 'none' },
}));

export default useStyles;
